import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { ResponseMessage } from '../models/response-message.interface';

@Component({
	selector: 'app-response-message',
	templateUrl: './response-message.component.html'
})
export class ResponseMessageComponent implements OnChanges {

	@Input() responseMsg: ResponseMessage;

	public error: string;
	public details: string;

	public toResponse: any;//timeout
	public toResponseMs: number = 10000;//timeout delay

	public toFadeout: any;//timeout
	public toFadeoutMs: number = this.toResponseMs - 4000;// css is used with a 4second delay/fadeout
	public isFadeOut: boolean = false;

	constructor() { }

	// ngOnInit(): void {
	// 	dont use this. it doesn't fire enough the way we use this component. use vvv
	// }

	ngOnChanges():void{
		//console.log('ngOnChanges.responseMsg:', this.responseMsg);

		if(this.responseMsg.error) {
			this.parseError(this.responseMsg.error);
		} else {
			this.error = null;
			this.details = null;
		}

		this.isFadeOut = false;
		clearTimeout(this.toResponse);
		clearTimeout(this.toFadeout);

		if(this.responseMsg != {}) {
			this.toFadeout = setTimeout(()=>{
				this.isFadeOut = true;
			}, this.toFadeoutMs);
			//auto-clear message after X seconds
			this.toResponse = setTimeout(()=>{
				this.responseMsg = {};
			}, this.toResponseMs);
		}
	}



	public parseError (error: any) {
	//	console.log('ResponseMessageComponent.parseError: ', error);
		//console.log('ResponseMessageComponent.parseError.errors: ', error.error.errors);

		if(error?.error) error = error.error;

		if (typeof error === 'string') {
			this.error = error;//didn't finish updating all errors...
			return;
		}

		let detailsArr = [];
		if(error.errors) {
			for (let [key, value] of Object.entries(error.errors)) {
				//console.error(key, ':', value);
				const errorField = key,//key.slice(2),
					errorDetailsArr = String(value).split(' | ');
				// console.log('errorField:', errorField);
				// console.log('errorDetailsArr:', errorDetailsArr);
				detailsArr.push(errorField.toUpperCase() + ': ' + errorDetailsArr[0]);
			}
		}
		//console.log('detailsArr:', detailsArr);

		this.error = error.title;
		if(detailsArr.length > 0) this.details = detailsArr.join('. ');
	}

}
